var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "logo-container", attrs: { to: "/" } },
    [
      _c("build-version", [
        _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.path, title: `${_vm.siteName} Logo` },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }